import { Icon } from '@euler/components/Icomoon';
import { Input } from '@euler/components/form/Input';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { useTextInputRow } from '../../functions/useTextInputRow';
import { Cell } from '../components/Cell';
import { IconWrapper } from '../components/IconWrapper';
import { Row } from '../components/Row';

export const CustomerNameRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor, placeholderColor } = theme;
    const { inputRef, inputStyle, onCellPress } = useTextInputRow();
    const { rpx } = useResponsiveContext();

    return (
      <Row
        errorProp="customerName"
        icon={
          <IconWrapper>
            <Icon name="layers" color={iconColor} size={rpx(23)} />
          </IconWrapper>
        }
        onPress={onCellPress}
        {...props}
      >
        <Cell label="车主姓名" required={required}>
          <Input
            inputRef={inputRef}
            style={inputStyle}
            placeholderTextColor={placeholderColor}
            value={form.customerName.value ?? ''}
            placeholder="请输入车主姓名，如李先生"
            clearButtonMode="while-editing"
            errorMsg={form.customerName.error}
            loading={form.customerName.loading}
            editable={!props.disabled}
            onChangeText={form.customerName.update}
            onBlur={form.customerName.onBlur}
          />
        </Cell>
      </Row>
    );
  },
);
